var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Col } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import { Slider, OccasionIcon, PickerWrapper } from "./styled";
import icons from "./icons";
var IconPicker = /** @class */ (function (_super) {
    __extends(IconPicker, _super);
    function IconPicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconPicker.prototype.componentDidMount = function () {
        if (!this.props.selectedIcon) {
            this.props.selectIcon(icons[0]);
        }
    };
    IconPicker.prototype.render = function () {
        var _a = this.props, selectedIcon = _a.selectedIcon, selectIcon = _a.selectIcon;
        return (React.createElement(PickerWrapper, null,
            React.createElement(Col, { xs: 12 },
                React.createElement("label", null,
                    React.createElement(FormattedMessage, { id: "admin.occasions.create.fields.icon.label" })),
                React.createElement(Slider, null, icons.map(function (icon, i) { return (React.createElement(OccasionIcon, { key: i, src: icon, alt: "icon", className: icon === selectedIcon ? "selected" : "", onClick: function () { return selectIcon(icon); } })); })))));
    };
    return IconPicker;
}(Component));
export default IconPicker;
